'use client';

import styled from 'styled-components';

import type { BulletedListElementType } from '@zoomit/editor';

interface RenderElementProps {
  children: any;
  element: BulletedListElementType;
  id?: string;
}

const BulletedListElement = (props: RenderElementProps) => {
  const { children } = props;

  return <BulletedListBase>{children}</BulletedListBase>;
};

const BulletedListBase = styled.ul`
  list-style: none;
  font-size: 1.6rem;
  line-height: 2.25;
  padding: 0;
  margin: 0;
`;

export default BulletedListElement;
